<template>
  <div class="ev-container">
    <img :src="icon" alt>
    <p>{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: 'EmptyView',
  props: {
    icon: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.ev-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    width: 1.733rem;
    height: 1.733rem;
  }

  p {
    margin-top: .32rem;
    font-size: .187rem;
    color: #8B8B8B;
  }
}
</style>
